import Map from "@/utils/Map";
import { MapElementType, InfosDraw } from "@/utils/constant/settings_constantes";

export default class Map_DynamicElementEvents {
  isfreeze;
  geom;
  isopen;
  distmin;
  indexControlPoint;

  constructor(geom) {
    this.geom = geom;
    this.isfreeze = false;
    this.isopen = false;
    this.distmin = 3;
    this.indexControlPoint = 0;
  }

  freezeCamera(isFreeze) {
    this.geom.viewer.scene.screenSpaceCameraController.enableRotate = !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableTranslate =
      !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableZoom = !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableTilt = !isFreeze;
    this.geom.viewer.scene.screenSpaceCameraController.enableLook = !isFreeze;
    this.isfreeze = isFreeze;
  }

  isControlPointClickLeft() {
    let ispick = false;
    if (this.geom.pickedInfos.leftDown) {
      ispick = this.isControlPointPicked();
    }
    return ispick;
  }

  isControlPointClicRight() {
    let ispick = false;
    if (this.geom.pickedInfos.clicRight) {
      ispick = this.isControlPointPicked();
    }
    return ispick;
  }

  isFreeze() {
    return this.isfreeze;
  }

  isInsert() {
    let isinsert = false;
    if (this.isPicked() && this.geom.pickedInfos.isInsert == true) {
      isinsert = true;
    }
    return isinsert;
  }

  isPicked() {
    let ispick = false;

    if (this.geom.pickedInfos !== undefined && this.geom.pickedInfos.element) {
      ispick = this.geom.pickedInfos.element == this.geom.infos.id;
    }

    return ispick;
  }

  isBorderHover() {
    return Cesium.defined(this.geom.polygon.insertPoint.position) && this.geom.viewer.canvas.style.cursor !== "move";
  }

  isBorderClickLeft() {
    let isPicked = false;
    if (this.isBorderHover() && this.geom.pickedInfos.leftDown) {
      isPicked = true;
    }
    return isPicked;
  }

  isControlPointPicked(index) {
    let ispick = false;
    if (this.geom.pickedInfos !== undefined && this.geom.pickedInfos.position) {
      const cartesian = this.geom.cartesian3FromCartographicDegrees(
        this.geom.pickedInfos.position
      );

      if (index != undefined) {
        const dist = Cesium.Cartesian3.distance(
          cartesian,
          this.geom.getControlPointCartesian(index)
        );
        if (dist < this.distmin) {
          if(this.isFreeze() == false) {
            this.indexControlPoint = index;
          }
          ispick = true;
        }
      } else {
        let controlsPointsDistance = [];
        let distMin = Number.POSITIVE_INFINITY;

        for (let i = 0; i < this.geom.controlspoints.length; i++) {
          const dist = Cesium.Cartesian3.distance(
            cartesian,
            this.geom.getControlPointCartesian(i)
          );
          controlsPointsDistance.push(dist);
        }
        for (let j = 0; j < controlsPointsDistance.length; j++) {
          if (controlsPointsDistance[j] < distMin) {
            distMin = controlsPointsDistance[j];
            if(this.isFreeze() == false) {
              this.indexControlPoint = j;
            }
          }
        }
        if (distMin < this.distmin) {
          ispick = true;
        }
      }
    }

    return ispick;
  }

  isValidate() {
    if (this.geom.getType() == MapElementType.Point) {
      return this.geom.pickedInfos.clicLeft;
    } else {
      return this.geom.pickedInfos.clicRight;
    }
  }

  isOpen() {
    return this.isopen;
  }

  getIndexControlPoint() {
    return this.indexControlPoint;
  }

  showMapElement() {
    this.geom.infos.key = Date.now();

    Map.toggle_popup_mapelement(true);
    Map.setCustomMapElement(this.geom);

  }

  updateCustomMapElement(isSave) {
    if (isSave === undefined) {
      isSave = false;
    }
    Map.updateCustomMapElement(this.geom);
    if (isSave) {
      Map.saveCustomMapElement();
    }
  }

  activateContextMenu(infos) {
    Map.setInfosContextMenu(infos);
  }

  desactivateContexMenu() {
    Map.toggle_popup_contextmenu(false);
  }

  setInfosDrawHelp(infodraw) {
    let txt = "";
    if (infodraw === InfosDraw.AddPoint) {
      txt += "<div class='flex-row flex items-center'>";
      txt +=
        "<img src='/assets/images/mouse_left.svg' style='height:30px'>Clic gauche pour ajouter un point. Echap pour annuler.";
    }
    if (infodraw === InfosDraw.InsertPoint) {
      txt += "<div class='flex-row flex items-center'>";
      txt +=
        "<img src='/assets/images/mouse_left.svg' style='height:30px'>Clic gauche pour insérer un point.";
    }
    if (infodraw === InfosDraw.AddPointMore) {
      txt += "<div class='flex-row flex items-center'>";
      txt +=
        "<img src='/assets/images/mouse_left.svg' style='height:30px'>Clic gauche pour ajouter le deuxième point. Echap pour annuler.";
    }
    if (infodraw === InfosDraw.MovePoint) {
      txt += "<div class='flex-row flex items-center'>";
      txt +=
        "<img src='/assets/images/mouse_move.svg' style='height:30px'>Clic gauche maintenu pour déplacer le point. Echap pour annuler.";
      txt +=
        "<img src='/assets/images/mouse_right.svg' style='height:30px'>Clic droit pour ouvrir le menu contextuel.";
    }
    if (infodraw === InfosDraw.RemovePoint) {
      txt += "<div style='text-align: center'>";
      txt += "Point supprimé.";
    }
    if (infodraw === InfosDraw.Cancel) {
      txt += "<div style='text-align: center'>";
      txt += "Opération annulée.";
    }
    if (infodraw === InfosDraw.Start) {
      txt += "<div class='flex-row flex items-center'>";
      txt +=
        "<img src='/assets/images/mouse_left.svg' style='height:30px'>Clic gauche pour placer le point. Echap pour annuler.";
    }
    if (infodraw === InfosDraw.Finish) {
      txt += "<div class='flex-row flex items-center'>";
      txt +=
        "<img src='/assets/images/mouse_right.svg' style='height:30px'>Clic droit pour terminer le tracé. Echap pour annuler.";
    }
    txt += "</div>";

    if (infodraw === InfosDraw.Clear) {
      txt = null;
    }
    Map.setInfosDrawHelp(txt);
  }
}
